import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Badge, Button, Modal } from 'antd';
import { Col, Input, Row } from "reactstrap";
import React, { useEffect, useState } from 'react'
import { CriteriaModal } from '../HelperComponents/CriteriaModal';
import AwsServerService from '../../../common/util/AwsServerService';
import { getProjectFieldMeta } from '../../ProjectTasks/Util';
import { useSelector } from 'react-redux';
import { log } from 'mathjs';
import { canAccess } from '../../../common/util/appUtils';

export default function SelectDealsModal({setCriteriaModal, isInitialRender, criteriaModal, view, onSelectedData, selectedData, modules}) {
     const [criteriaFieldGroups, setCriteriaFieldGroups] = useState({}); 
     const accessContext = useSelector(state => state.UserContext.accessContext);
     const [allPipelineData, setAllPipelineData] = useState([]); 
     let allDealsAndUsers = useSelector((state) => state.AppReduxContext.AllDeals);
     useEffect(()=>{
     getCriteriaFields();
     getAllPipelines();
     },[]);

        const getAllPipelines = async () => {
            await AwsServerService.getAllPipelinesNames().then(res => {
                setAllPipelineData(res?.data[0]);
            })
        }
     const getCriteriaFields = async () => {
         await AwsServerService.getCriteriaFields().then(res => {
           let obj = {};
           if (res?.data) {
             res.data.forEach(one => {
               if (obj[one.module]) {
                 obj[one.module] = [...obj[one.module], one];
               } else {
                 obj[one.module] = [one];
               }
             })
           }
           obj.Task.push(
             {
               "ROWID": 18,
               "label": "Priority",
               "field": "Priority",
               "type": "TEXT",
               "module": "Task",
               "apikey": ""
             },
             {
               "ROWID": 19,
               "label": "Task Status",
               "field": "TaskStatus",
               "type": "MULTI-PICKLIST",
               "module": "Task",
               "apikey": ""
             },
             {
               "ROWID": 20,
               "label": "Pipeline",
               "field": "PipelineName",
               "type": "MULTI-PICKLIST",
               "module": "Task",
               "apikey": ""
             },
             {
               "ROWID": 21,
               "label": "Task Flow",
               "field": "TaskFlowObject",
               "type": "MULTI-PICKLIST",
               "module": "Task",
               "apikey": ""
             },
           )
           let DataObject = getProjectFieldMeta(allDealsAndUsers || {})
           console.log("DataObject", DataObject);
           obj.Project = [...obj.Project, ...DataObject]
           setCriteriaFieldGroups(obj);
         })
       }
  
  let module = modules?.find((item) => item.module_name === "Deals");
  const isDealVisible =  module.permissions["View"] === true;
  return (<>
    {isDealVisible && (<div>
       <Badge count={selectedData?.length}>
        <Button onClick={() => setCriteriaModal(true)}>Add Criteria</Button>
        </Badge>
        {selectedData?.length>0 && <Button
          style={{marginLeft: '15px'}}
          onClick={() =>{
            isInitialRender.current = false;
            onSelectedData([]);
          }}
        >Reset</Button>}
        <CriteriaModal
                mainFields={criteriaFieldGroups}
                open={criteriaModal}
                criteriaRows={selectedData}
                action={view}
                setOpen={setCriteriaModal}
                onSave={(data) => {
                   
                  isInitialRender.current = false;
                  onSelectedData(data);
                }}
                FromTask={true}
                allPipelineData = {allPipelineData}
              /></div>)}
      </>
  )
}
